import { client, errorValidation } from "./service";

export const getExpenseList = async function ({
    dateType, startDate, endDate, expenseType,
    requestBy, eventId, page, limit
}) {
    try {
        let response = await client.get(`/expense/list`, {
            params: {
                dateType: dateType || '',
                startDate: startDate || '',
                endDate: endDate || '',
                expenseType: expenseType || '',
                requestBy: requestBy || '',
                eventId: eventId || '',
                page,
                limit
            }
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getExpenseType = async function () {
    try {
        let response = await client.get(`/expense-type/list`);
        console.log('here response', response)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}


export const addExpense = async function ({
    expenseDate, eventId, description,expenseType, imageProof, nominal, requestBy
}) {
    try {
        let response = await client.post(`/expense/create`, {
            expenseDate, eventId, description,expenseType, imageProof, nominal, requestBy
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const deleteExpenseService = async function ({
    _id
}) {
    try {
        let response = await client.delete(`/expense/delete/${_id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}